import styled from '@emotion/styled';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/system/Box';

const HeaderContainer = styled.div`
  padding-bottom: 10px;
  margin-left: 0px;
`;

const PageContent = styled.div`
  display: flex;
  min-height: calc(100vh - 205px);
  flex-direction: column;
  padding: 0 10px 20px 10px;
  background: white;
`;

const CircularProgressWrapper = styled.div`
  margin: 0px auto;
  margin-top: 300px;
`;

const HeaderContent = styled.div`
  display: flex;
`;

const PageTitleContent = styled.div`
  margin-bottom: 20px;
`;

function ApplicationPageTemplate({
  title,
  description,
  toolbar,
  children,
  pageReady,
  icon,
}) {
  return (
    <PageContent>
      {!pageReady ? (
        <CircularProgressWrapper>
          <CircularProgress />
        </CircularProgressWrapper>
      ) : (
        <>
          {(icon || title || description || toolbar) && (
            <HeaderContainer>
              <HeaderContent>
                <PageTitleContent>
                  {icon && (
                    <img
                      src={icon}
                      alt="AppIcon"
                    />
                  )}
                  <Typography
                    variant="pageHeader"
                    style={{ lineHeight: '50px', marginLeft: '-5px' }}>
                    {title}
                  </Typography>
                  {description && (
                    <Typography
                      variant="pageSubHeader"
                      sx={{
                        color: 'text.secondary',
                        lineHeight: '1.25',
                      }}>
                      {description}
                    </Typography>
                  )}
                </PageTitleContent>
                <Box style={{ flexGrow: 4 }} />
                {toolbar && (
                  <Box
                    style={{
                      display: 'flex',
                      alignItems: 'end',
                      columnGap: '10px',
                    }}>
                    {toolbar}
                  </Box>
                )}
              </HeaderContent>
            </HeaderContainer>
          )}
          {children}
        </>
      )}
    </PageContent>
  );
}

export default ApplicationPageTemplate;
